module.exports = __webpack_public_path__ + "static/media/IHCL_Logo_White.026f8640.png";